import api from "./api";
import StorageService from "./StorageService";

const FuelConsumptionReportService = {

  getReport: async (filters) => {
    const comp = StorageService.activeCompany();
    const loginData = StorageService.loginData();

    const params = {
      companyId: comp.companyId,
      employeeId: loginData?.employeeId || null,
      roleId: loginData?.roleId || null,
      pageNumber: filters.pageNumber || 1,
      noofRows: filters.noofRows || 20,
      project: filters.project || null,
      vehicleName: filters.vehicleName || null,
      vehicleType: filters.vehicleType || null,
      vendorName: filters.vendorName || null,
      fromDate: filters.fromDate || null,
      toDate: filters.toDate || null
    };

    const res = await api.get("/fuelConsumptionReport/getReport", {
      params
    });

    return res.data;
  },

  exportExcel: async (filters) => {
    const comp = StorageService.activeCompany();
    const loginData = StorageService.loginData();

    const params = {
      companyId: comp.companyId,
      employeeId: loginData?.employeeId || null,
      roleId: loginData?.roleId || null,
      project: filters.project || null,
      vehicleName: filters.vehicleName || null,
      vehicleType: filters.vehicleType || null,
      vendorName: filters.vendorName || null,
      fromDate: filters.fromDate || null,
      toDate: filters.toDate || null
    };

    const res = await api.get("/fuelConsumptionReport/exportExcel", {
      params
    });

    return res.data?.data || res.data || [];
  }

};

export default FuelConsumptionReportService;
